export const createAwardState = () => ({
    id: null,
    title: '',
    description: '',
    recipientName: '',
    awardDate: null,
    imageAttachmentId: null,
    sortOrder: 0,
});
export const createAdState = () => ({
    id: null,
    location: '',
    businessTitle: '',
    adPhotoAttachmentId: null,
    adBlurb: '',
    ctaUrl: '',
    activeDate: null,
    expirationDate: null,
});
